// THIS FILE IS AUTO-GENERATED by set-env.js — do not edit manually
export const environment = {
  production: false,
};

export const apiUrl = '/api';
export const versione = 'Ver 1.0.1';
